/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, { css } from 'styled-components';
import {StylePTagProps} from "../typings";
import {themeToken} from "../../utils/cpds-utils";
import {checkValue} from "src/components/common/helper";

/* Note: By default, this component is rendered as a 'div' element. 
If your use case requires a different HTML element, please update the component accordingly.
Get the the token please use cpds props ex: ${cpds?.button_primary_background_color} 

Start styles for component here
Your Styles goes here  
End styles for component here

Styles overrides - Do not Remove This Code Block
Data feed styles overrides goes here

*/
const CpdsSectionTitleStyleTag = styled.div`
    ${({ theme: { styles : {cpds} },bgColor,...props }) => {
      
      const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
      return css`
        display:flex;
        flex-direction:column;
        background-color: ${bgColor || token.section_title_background_color || '#FFFFFF'};
        @media screen and (max-width: 767px){
          width: 358px;
        }
        ${(props) => props?.styleOverrides}
      `
    }
  }
`;

const SectionTitleDiv = styled.div`
  ${({ theme: { styles : {cpds} } }) => css`

  `}
`;

const SectionEyebrowP = styled.p<StylePTagProps>`
  ${({ 
    theme: { styles : {cpds,fontFamily} },
    textAlign,
    textColor,
    fontSize,
    fontWeight,
    lineHeight,
    ...props

  }) =>{

    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    
      return css`
        ${checkValue(fontSize)? `font-size: ${fontSize} !important;` : ''};
        ${checkValue(lineHeight)? `line-height: ${lineHeight} !important;` : ''};
        ${checkValue(fontWeight)? `font-weight: ${fontWeight} !important;` : ''};
        font-weight:${fontWeight || '400 !important;'};
        text-align: ${textAlign || token?.section_title_eyebrow_text_align || 'center'};
        color: ${textColor || token?.section_title_eyebrow_color || '#676A7D'};
       `
    }
  }
`

// style={{fontFamily:'Reckless XPD', fontSize:'40px', fontWeight:250, textAlign:'left', lineHeight:'-3%',color:'#0C0E1C'}} #31374F
const SectionTitleP =  styled.p<StylePTagProps>`
    ${({ 
      theme: { styles : {cpds} },
      textAlign,
      textColor,
      fontSize,
      fontWeight,
      lineHeight,
      ...props
      }) => {
      const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
      return css`
        ${checkValue(fontSize)? `font-size: ${fontSize} !important;` : ''};
        ${checkValue(lineHeight)? `line-height: ${lineHeight} !important;` : ''};
        ${checkValue(fontWeight)? `font-weight: ${fontWeight} !important;` : ''};
        text-align: ${textAlign || token?.section_title_text_align || 'left'};
        color: ${textColor || token?.section_title_color || '#0C0E1C'};
      `
     }
   }
  `

  const SectionTitleH2 =  styled.h2<StylePTagProps>`
  ${({ 
    theme: { styles : {cpds} },
    textAlign,
    textColor,
    fontSize,
    fontWeight,
    lineHeight,
    ...props
    }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      ${checkValue(fontSize)? `font-size: ${fontSize} !important;` : ''};
      ${checkValue(lineHeight)? `line-height: ${lineHeight} !important;` : ''};
      ${checkValue(fontWeight)? `font-weight: ${fontWeight} !important;` : ''};
      text-align: ${textAlign || token?.section_title_text_align || 'left'};
      color: ${textColor || token?.section_title_color || '#0C0E1C'};
    `
   }
 }
`

  const SectionTitleDescriptionP =  styled.p<StylePTagProps>`
    ${ ({theme: { styles : {cpds}},
      textAlign,
      textColor,
      fontSize,
      fontWeight,
      lineHeight,
      ...props
    }) => {
      
      const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);

     return  css`
    
    ${checkValue(fontSize)? `font-size: ${fontSize} !important;` : ''};
    ${checkValue(lineHeight)? `line-height: ${lineHeight} !important;` : ''};
    ${checkValue(fontWeight)? `font-weight: ${fontWeight} !important;` : ''};
    text-align: ${textAlign || token?.section_title_description_text_align || 'center'};
    color: ${textColor || token?.section_title_description_color || '#31374F'};
      
    `}
  }
  
  `

export { CpdsSectionTitleStyleTag,SectionTitleDiv,SectionEyebrowP,SectionTitleP, SectionTitleH2, SectionTitleDescriptionP };
